module.exports = __webpack_public_path__ + "images/Shield-user.fae6e921b2304664d525318688fb225d.svg";